
import React from 'react';
import { Lock } from 'lucide-react';
import { formatDistance } from 'date-fns';
import { useEffect, useState } from 'react';

interface LockoutDisplayProps {
  lockoutEndTime: Date;
  onEmergencyAccess?: () => void; // Keep interface for backwards compatibility
}

const LockoutDisplay: React.FC<LockoutDisplayProps> = ({ 
  lockoutEndTime
  // onEmergencyAccess is intentionally not destructured to avoid using it
}) => {
  const [timeRemaining, setTimeRemaining] = useState<string>('');
  
  useEffect(() => {
    const updateTimeRemaining = () => {
      const now = new Date();
      if (now >= lockoutEndTime) {
        window.location.reload(); // Refresh to update lock state
        return;
      }
      setTimeRemaining(formatDistance(lockoutEndTime, now, { addSuffix: false }));
    };
    
    // Update immediately
    updateTimeRemaining();
    
    // Then update every second
    const interval = setInterval(updateTimeRemaining, 1000);
    return () => clearInterval(interval);
  }, [lockoutEndTime]);
  
  return (
    <div className="text-center py-6 space-y-4 relative z-10">
      <div className="bg-slate-800/40 p-3 rounded-full inline-block">
        <Lock className="h-8 w-8 text-red-400 cyber-icon" />
      </div>
      <h3 className="text-lg font-medium cyber-text-glow">Account Locked</h3>
      <p className="text-cyan-200/70">
        Too many failed attempts. Please try again in:
      </p>
      <div className="text-2xl font-bold cyber-text-glow">{timeRemaining}</div>
      
      {/* Emergency access button removed */}
    </div>
  );
};

export default LockoutDisplay;
